<template>
  <div class="cancel-box">
    <e-dialog  title="取消订单" :visible.sync="realShow" center width="520px">
      <div class="tip">
        <p class="fs-18">*取消订单后,本单享有的优惠可能会一并取消,是否继续?</p>
        <p class="fs-18 c-777">请选择取消订单的理由(必选)</p>
      </div>
      <ul class="reason-box" v-if="realShow">
        <li v-for="(item, index) in reasonList" :key="index" :class="{active: index === activeIndex}" @click="activeIndex = index">{{item}}</li>
      </ul>
      <div class="btn-group">
        <div class="btn" @click="realShow = false">再想想</div>
        <div class="btn confirm" @click="confirm">提交</div>
      </div>
    </e-dialog>
  </div>
</template>

<script>
import myorderApi from '@/api/myorder'
  import { Dialog } from 'element-ui'

  export default {
    name: 'cancelOrder',
    components: {
      EDialog: Dialog
    },
    props: {
      orderId: {
        default: ''
      },
      reasonId: {
        default: ''
      }
    },
    data () {
      return {
        activeIndex: -1,
        show: false,
        realShow: false,
        reasonList: ['配送信息有误', '商品买错了', '不想要了'],
        reason: '' // 选中的理由
      }
    },
    methods: {
      confirm () {
        myorderApi.cancelorder({
          orderId: this.orderId,
          cancelReason: this.reasonList[this.activeIndex]
        }).then((res) => {
          if (res.status === 200) {
            this.$emit('cancel')
            this.$feedback('订单已取消')
          } else {
            this.$feedback(res.message)
          }
          this.realShow = false
        }, () => this.$feedback('取消失败'))
      },
      // 取消订单
      cancelOrder () {
        myorderApi.causeorder({
          orderId: this.orderId
        }).then(res => {
          if (res.status !== 200) {
            this.$feedback(res.message)
            return
          }
          this.reasonList = res.data
          this.activeIndex = 0
          this.realShow = true
          this.show = false
        })
      }
    },
    watch: {
      show (val) {
        if (val) {
          this.cancelOrder()
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.cancel-box {
  ::v-deep {
    .el-dialog__title {
      color: #000;
    }
  }
  color: #333;
  font-size: 16px;
  .tip {
    padding: 0 30px;
    p:first-child {
      color: #000;
    }
  }
  .fs-18 {
    font-size: 18px;
  }
  .c-777 {
    color: #777;
    text-indent: 7px;
    margin-top: 5px;
  }
  .reason-box {
    display: flex;
    padding: 30px;
    flex-wrap: wrap;
  }
  li {
    list-style-type: none;
    width: 220px;
    height: 40px;
    color: #333;
    background: #ececec;
    line-height: 40px;
    text-align: center;
    margin-bottom: 10px;
    cursor: pointer;
    border: 1px solid #ececec;
    &:nth-child(2n + 1) {
      margin-right: 10px;
    }
    &.active {
      background: #FDF4F3;
      color: #C6001F;
      border-color: #C6001F;
    }
  }
  .btn-group {
    display: flex;
    justify-content: center;
    padding: 10px 0 40px;
    .btn {
      width: 150px;
      line-height: 45px;
      height: 45px;
      text-align: center;
      border: 1px solid #000;
      font-size: 20px;
      color: #000;
      cursor: pointer;
      &:hover {
        opacity: .9;
      }
      &:first-child {
        margin-right: 20px;
      }
      &.confirm {
        color: #fff;
        background: #000;
        border-color: #333;
      }
    }
  }
  & ::v-deep {
    .el-dialog__header {
      padding: 30px;
      font-size: 20px;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-message {
      z-index: 3008;
    }
  }
}
</style>
